import { createFileRoute, Link, redirect, useNavigate } from '@tanstack/react-router';
import { AuthLayout } from '@/components/AuthLayout';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { sessionQueryOptions } from '@/features/auth/api';

export const Route = createFileRoute('/entrar')({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(sessionQueryOptions()).catch(() => null);
    if (user) throw redirect({ to: '/' });
  },
  component: LoginPage,
});

function LoginPage() {
  const navigate = useNavigate();
  return (
    <AuthLayout
      title="Entrar"
      footer={
        <Link to="/cadastro" data-testid="login-goto-register">
          Criar conta
        </Link>
      }
    >
      <LoginForm onSuccess={() => void navigate({ to: '/' })} />
    </AuthLayout>
  );
}
